import { useTranslation } from "react-i18next";
import { cn } from "@/lib/utils";

/**
 * Badge coloré pour la qualité photo/vidéo d'un bien.
 * Source DB : `bien.photosOk` ou `bien.videoOk` (enum).
 *
 * 5 états :
 * - vide / "" → tiret neutre
 * - "pas_de_photo" / "pas_de_video" → pilule rouge (utilise `emptyLabel`)
 * - "suffisant" → pilule orange
 * - "bien" / "tres_bien" → pilule verte
 *
 * Réutilisé sur /suivi-publication et /planning-photos pour un affichage
 * uniforme du statut photo/vidéo (cohérence cross-pages, 1 donnée = 1 rendu).
 */
export function QualityBadge({ value, emptyLabel }: { value: string; emptyLabel: string }) {
  const { t } = useTranslation();
  if (!value) {
    return <span className="text-text-muted">—</span>;
  }
  const labelMap: Record<string, string> = {
    pas_de_photo: emptyLabel,
    pas_de_video: emptyLabel,
    suffisant: t("biens.photosOptions.suffisant"),
    bien: t("biens.photosOptions.bien"),
    tres_bien: t("biens.photosOptions.tres_bien"),
  };
  const colorMap: Record<string, string> = {
    pas_de_photo: "bg-danger/10 text-danger",
    pas_de_video: "bg-danger/10 text-danger",
    suffisant: "bg-warning/10 text-warning",
    bien: "bg-success/10 text-success",
    tres_bien: "bg-success/10 text-success",
  };
  return (
    <span className={cn("inline-flex items-center text-[10px] font-semibold px-1.5 py-0.5 rounded", colorMap[value] || "bg-surface-2 text-text-muted")}>
      {labelMap[value] || value}
    </span>
  );
}
